import { Injectable } from "@angular/core";
import { API_METHODS, API_URL, OperationType, USER_TYPE } from "common/constants/sm-constants";
// import { OtpModel } from "common/models/page-models/otp-model";
import { environment } from "src/environments/environment";
import { OtpModel } from "common/models/page-models/Login/Otp/otp-data-model";
import { FormDataService } from "common/services/data-services/base-data-services/form-data.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";


@Injectable({
    providedIn: 'root'
})
export class OtpFormDataService extends FormDataService<OtpModel> {
    router: any;
    constructor(http: SmApiService, protected override ss: SystemService, private modalService: NgbModal) {
        super(API_URL.otp, http, ss);
    }

    createInstance(): OtpModel {
        return new OtpModel();
    }


    override modifyPostModel(formModel: any, dataModel: any) {
        const data = {}
        if (formModel.token) {
            data['token'] = formModel.token
        } else {

            data['otp'] = formModel.otp,
                data['email'] = dataModel.email
        }
        return data;
    }


    override afterPostData(model: OtpModel, response): Promise<OtpModel> {
        // console.log(response,"response")
        return new Promise<OtpModel>((resolve, reject) => {
            console.log(response, 'response');
            if (response.details !== undefined && typeof response.details === 'object') {
                // console.log(response.details,"response Token")
                // this.ss.setLoginData(modifiedResponse);
                model.userType = response.details.user_type;
                model.status = response.details.status;
                model.email = response.details.email;
                model.first_name = response.details.first_name;
                model.last_name = response.details.last_name;
                model.name = response.details.name;
                model.role = response.details.role;
                model.id = response.details.id;
                model.time = response.details.time;
                model.otp = response.details.otp;
                model.time = response.details.time;
                model.expiry_time = response.details.expiry_time;
                model.token = response.details.token;
                model.isTermFlag = response.details.term_flag;
                model.profile_pic_name = response.details.profile_pic_path;
                // console.log(model.profile_pic_name);
                model.isProfileUpdateFlag = response.details.isProfileUpdateFlag
                model.api_access_tokon = response.details.api_access_tokon
                const isEligibleStatus = response.details.status === 2 || response.details.status === 3;
                const isProfileUpdateRequired = response.details.isProfileUpdateFlag === 1;
                
                console.log(response);
                if(response.details.role === 2 && isEligibleStatus) {
                    this.systemService.updateAlumniProfileStatus(isProfileUpdateRequired);
                  } else {
                    this.systemService.updateAlumniProfileStatus(true);
               }


                // console.log(model.userType,model.status,model.token,model.isTermFlag)
                // console.log('afterPostData');


                this.ss.setlocalStorage('loginData', JSON.stringify(model));
                resolve(this.transformAPIData(model));


                // this.ss.setlocalStorage('currentUser',JSON.stringify(model.token) )
                // this.ss.setlocalStorage('profile',JSON.stringify(model) )
                //   console.log("response Token",model)
            } else {
                const modifiedResponse = JSON.parse(this.ss.getlocalStorage('loginData'));
                // console.log(model, modifiedResponse)
                resolve(this.transformAPIData(modifiedResponse));
            }
            this.modalService.dismissAll();

        }).catch((err) => {
            throw err
        });
    }

    override  updatepostUrl(type: OperationType) {
        return environment.apiUrl + API_URL.preTrainerLogin
    }


    override getOperationType(data: any) {
        // console.log(data);
        if (data.hasOwnProperty('token')) {
            return OperationType.UPDATE;
        } else {
            return OperationType.CREATE;
        }
    }



    // override transformAPIData(data: any,) {
    //     const newData = {
    //         ...data,
    //         usertype:
    //       }
    //     return data
    // }




    // switch(this.ss.getUserRole()) {
    //     case USER_TYPE.student:
    //         this.ss.navigateToProfile();
    //         // this.override transformDataModel();
    //         break;
    //     case USER_TYPE.admin:
    //         this.ss.navigateToDashboard();
    //         break;

    //         // for temporary use alumni navigate to navigateToDashboard()
    //     case USER_TYPE.trainer:
    //             this.ss.navigateToDashboard();
    //             break;
    //     case USER_TYPE.alumni:
    //     this.ss.navigateToDashboard();
    //     break;

    // }

    override getEditUrlAndMethod() {
        const edit = {
            url: '',
            method: API_METHODS.get
        }
        return edit;
    }

    override getCustomError(): string {
        return 'Please enter correct OTP';
    }



    // override afterPostData(model: T): Promise<T> {
    //     return new Promise<T>((resolve, reject) => {
    //         resolve(this.transformAPIData(model));
    //     });
    // }

    // override transformAPIData(data: any) {
    //     if (data) {
    //         const envelope = new RouteEnvelope();
    //         envelope.type = OperationType.UPDATE;
    //         envelope.transferData = new WidgetModel();
    //         this.ss.navigateByUrl(ROUTE_PATH.student_profile, envelope);
    //     }
    //     return data;
    // }

    // navigateToHelpDesk() {
    //     const envelope = new RouteEnvelope();
    //     envelope.type = OperationType.UPDATE;
    //     envelope.transferData = new WidgetModel();
    //     this.ss.navigateByUrl(ROUTE_PATH.help, envelope);
    //   } 



    // override postData(data): Promise<any> {
    //     return new Promise((resolve, reject) => {
    //       // const type = this.getOperationType(data);
    //       const url = environment.apiUrl + API_URL.login;

    //       this.apiService
    //         .postData(url, this.convertFormData(data))
    //         .then((res) => {
    //           resolve(res);
    //         })
    //         .catch((err) => {
    //           reject(err);
    //         });
    //     });
    //   }

}